import type { FC } from 'react'

import { ButtonSignIn } from '../../common'

import { BookingListEmpty, LayoutContextMenu } from './common'

export const ContextMenuUnauthenticated: FC = () => {
  return <LayoutContextMenu cta={<ButtonSignIn variant='contained' color='primary' />} list={<BookingListEmpty />} />
}
